import { render, staticRenderFns } from "./radio-group.vue?vue&type=template&id=66a2ed5b"
import script from "./radio-group.vue?vue&type=script&lang=js"
export * from "./radio-group.vue?vue&type=script&lang=js"
import style0 from "./radio-group.vue?vue&type=style&index=0&id=66a2ed5b&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports